export default __webpack_public_path__ + "static/media/samsung_stimuli.de8f94b4.mp4";